"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.minLength = void 0;
const codes_1 = require("./codes");
const minLength = (length, errorText) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (value, values, texts) => {
        if (value && value.length > length - 1) {
            return '';
        }
        return (errorText || texts[codes_1.VALIDATE_CODES.minLength]).replace(/{{length}}/, String(length));
    };
};
exports.minLength = minLength;
//# sourceMappingURL=minLength.js.map